import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import Header from "../components/header";
import Footer from "../components/footer";
import { commonErr } from "../common/errors";
import { MessagePage, MessageBox } from "../common/messagebox";
import { LoadingPage } from "../common/loading";
import { getLoggedProfile, updateConfigPapers } from "../../model/profile";

import contract from "../../static/images/owner/contract.png";
import { IcBackReport, IcCarContract, IcCarContract2 } from "../common/svg";
import { MY_CARS } from "../../constant/routes";

class Contract extends React.Component {
	constructor() {
		super();

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		//
		const self = this;
		getLoggedProfile().then(function (resp) {
			if (resp.data.data) {
				const profile = resp.data.data.profile;
			}
		});
	}

	render() {
		var content;
		const profile = this.props.session.profile.info;

		const { contractUrl, recordUrl } = this.props.appInit.data;

		if (this.props.session.profile.err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (profile && profile.uid) {
			content = (
				<div className="leases__sect">
					<div className="m-container">
						<div className="main-title">
							<Link className="back d-flex" to={MY_CARS}>
								<div className="wrap-svg">
									<IcBackReport />
								</div>
								<p>Quay lại</p>
							</Link>
							<h4>Hợp đồng mẫu</h4>
						</div>
						<img loading="lazy" className="img-fluid" src={contract} />
						<p>Chọn loại hợp đồng bạn muốn xem</p>
						<div className="leases-option__wrap">
							<div className="leases-option__box">
								<a href={contractUrl} target="_blank">
									<IcCarContract />
									<p>HỢP ĐỒNG CHO THUÊ</p>
								</a>
							</div>
							<div className="leases-option__box">
								<a href={recordUrl} target="_blank">
									<IcCarContract2 />
									<p>BIÊN BẢN BÀN GIAO XE</p>
								</a>
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			content = <MessagePage message="Vui lòng đăng nhập để sử dụng tính năng này." />;
		}

		return (
			<div className="mioto-layout">
				<Header />
				<section className="body">{content}</section>
				{/* <Footer /> */}
			</div>
		);
	}
}

function mapState(state) {
	return {
		session: state.session,
		appInit: state.appInit,
	};
}

Contract = connect(mapState)(Contract);

export default Contract;
